import { startCase } from "lodash";
import { supabase } from "../../../services/auth";

import { getCollectionImagesFull } from "../../../services/supabase";
import {
    collectionDescriptions,
    collectionNameMap,
    slugToName,
    slugs,
} from "../../../services/collections";
import LibraryLayout from "../../../components/LibraryLayout";
import CollectionLayout from "../../../components/CollectionLayout";

export default function Home(props) {
    return (
        <LibraryLayout
            props={props.title}
            section={"collections"}
            subsection={props.collectionName}
            supabase={supabase}
            {...props}
        >
            <CollectionLayout
                key={props.collectionName}
                supabase={supabase}
                {...props}
            />
        </LibraryLayout>
    );
}

export async function getStaticPaths() {
    const paths = slugs.map((collection) => ({
        params: { id: collection, collection },
    }));
    console.log("All Collections: " + paths.length);
    return { paths, fallback: false };
}

export async function getStaticProps(context) {
    const slug = context.params.collection;
    const collectionName = slugToName[slug];
    const internalCollectionName = collectionNameMap[collectionName];
    const result = await getCollectionImagesFull(internalCollectionName);

    return {
        props: {
            collectionName: slugToName[slug],
            slug,
            image: result?.[0]?.url || null,
            initialImages: result,
            query: collectionName,
            initialQuery: collectionName,
            title: `${startCase(
                collectionName
            )} Collection of Vector Images and Illustrations for Free Download`,
            description: `Download ${startCase(
                collectionName
            )} vector illustrations for free or create your own with AI. ${
                collectionDescriptions[collectionName] || ""
            }`,
            canLoadMore: false,
            collections: slugToName,
        },
    };
}
